import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // Auth/permissions problems don't benefit from retries; fail fast so
        // the UI can route to login/403 without eight seconds of delay.
        if (error instanceof ApiError && (error.status === 401 || error.status === 403 || error.status === 404)) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
})
